import { CourseWithChapters } from "@jelly/lesson";
import { formatLessonsForChapter } from "../../../services/Utils";
import lesson01 from "../../lesson/course-05/lesson-01/lesson";
import lesson02 from "../../lesson/course-05/lesson-02/lesson";
import lesson03 from "../../lesson/course-05/lesson-03/lesson";
import lesson04 from "../../lesson/course-05/lesson-04/lesson";
import lesson05 from "../../lesson/course-05/lesson-05/lesson";
import lesson06 from "../../lesson/course-05/lesson-06/lesson";
import lesson07 from "../../lesson/course-05/lesson-07/lesson";
import lesson08 from "../../lesson/course-05/lesson-08/lesson";
import lesson09 from "../../lesson/course-05/lesson-09/lesson";
import lesson10 from "../../lesson/course-05/lesson-10/lesson";
import lesson11 from "../../lesson/course-05/lesson-11/lesson";
import lesson12 from "../../lesson/course-05/lesson-12/lesson";
import lesson13 from "../../lesson/course-05/lesson-13/lesson";
import lesson14 from "../../lesson/course-05/lesson-14/lesson";
import lesson15 from "../../lesson/course-05/lesson-15/lesson";
import lesson16 from "../../lesson/course-05/lesson-16/lesson";
import lesson17 from "../../lesson/course-05/lesson-17/lesson";
import lesson18 from "../../lesson/course-05/lesson-18/lesson";
import lesson19 from "../../lesson/course-05/lesson-19/lesson";
import lesson20 from "../../lesson/course-05/lesson-20/lesson";
import lesson21 from "../../lesson/course-05/lesson-21/lesson";
import lesson22 from "../../lesson/course-05/lesson-22/lesson";
import lesson23 from "../../lesson/course-05/lesson-23/lesson";
import lesson24 from "../../lesson/course-05/lesson-24/lesson";
import lesson25 from "../../lesson/course-05/lesson-25/lesson";
import lesson26 from "../../lesson/course-05/lesson-26/lesson";
import lesson27 from "../../lesson/course-05/lesson-27/lesson";
import lesson28 from "../../lesson/course-05/lesson-28/lesson";
import lesson29 from "../../lesson/course-05/lesson-29/lesson";
import lesson30 from "../../lesson/course-05/lesson-30/lesson";
import case01 from "../../lesson/course-05/case-01/case";
import authorMr from "../course-02/authors/author-mr";
import authorYs from "../course-02/authors/author-ys";
import authorTw from "../course-03/authors/author-tw";
import authorMh from "../course-04/authors/author-mh";
import authorAp from "../course-04/authors/author-ap";
import authorKj from "./authors/author-kj";
import authorEc from "./authors/author-ec";
import authorKarolina from "./authors/author-karolina";
import authorTl from "./authors/author-tl";
/* eslint-disable max-len */
const data: CourseWithChapters = {
  id: "53e2fab0-edf6-4634-a20e-ae0cdfe73cba",
  publicId: "5",
  slug: "room-and-building-acoustics",
  name: "Room and building acoustics",
  description:
    "This is an online course of 30 interactive lessons on room and building acoustics with two case studies for practical application.The room and building acoustics course covers all the aspects of what can commonly be called acoustic comfort in a closed space. The term acoustic comfort includes three components. The first one is room acoustics, which strives to provide optimal acoustic conditions in a room regarding its size and purpose in terms of the length of reverberation and the composition of early and late reflections that arrive to listener positions from a sound source present in the room. The second one is building acoustics, which provides the necessary protection of a room from external noise by providing adequate sound insulation towards adjacent indoor and outdoor spaces. At the same time, these adjacent spaces are protected from possibly unwanted sound coming from the room in question. The third one is the internal noise generated by the sources located in the room, most commonly electrical and electronic equipment, as well as HVAC equipment. The goal of this course is to introduce these three concepts to the user and to provide the knowledge required for successful implementation of these concepts in practical engineering problems through theoretical considerations aided by interactive materials as hands-on illustrations of the presented phenomena, followed by quick knowledge tests in form of tasks.",
  shortDescription:
    "This course will teach you how to make a closed space comfortable and usable for its intended purpose from the acoustical point of view, and what requirements need to be fulfilled to achieve this goal.",
  chapters: [
    {
      id: "62e06af8-9394-4662-87a7-4279b47aea0b",
      name: "Introduction",
      position: 0,
      chapterLessons: formatLessonsForChapter([lesson01]),
    },
    {
      id: "1ad0beb1-553b-4317-b24f-0d1c68ce4f01",
      name: "Room acoustics",
      position: 1,
      chapterLessons: formatLessonsForChapter(
        [
          lesson02,
          lesson03,
          lesson04,
          lesson05,
          lesson06,
          lesson07,
          lesson08,
          lesson09,
          lesson10,
          lesson11,
          lesson12,
          lesson13,
          lesson14,
          lesson15,
        ],
        1
      ),
    },
    {
      id: "fd06f24a-f191-4090-bd06-974c823c698a",
      name: "Building acoustic",
      position: 2,
      chapterLessons: formatLessonsForChapter(
        [
          lesson16,
          lesson17,
          lesson18,
          lesson19,
          lesson20,
          lesson21,
          lesson22,
          lesson23,
          lesson24,
          lesson25,
          lesson26,
          lesson27,
          lesson28,
          lesson29,
          lesson30,
        ],
        14
      ),
    },
    {
      id: "f8c865d0-961c-4713-8752-fc89cfc22e04",
      name: "Case studies",
      position: 4,
      chapterLessons: formatLessonsForChapter([case01], 30),
    },
  ],
  authors: [authorMh, authorKj, authorAp, authorMr, authorYs, authorTw, authorEc, authorKarolina, authorTl],
};
/* eslint-enable max-len */

export default data;
